import { Button, LoadingIndicator } from "@Modules/common";
import { BUTTON_DESIGNS, isBrowser, ROUTES, useScrollProgress } from "@Utils";
import React from "react";
import { IoChevronBackOutline } from "@react-icons/all-files/io5/IoChevronBackOutline";
import {
    LOADING_INDICATOR_DESIGNS,
    LOADING_INDICATOR_PROGRESS_TYPES,
} from "repoV2/components/common/LoadingIndicators/LoadingIndicator.data";
import styles from "./BlogPostHeader.module.scss";
import { IBlogPostHeader } from "./IBlogPostHeader";

export const BlogPostHeader = ({
    title,
    preview,
    handlePreviewPopup,
}: IBlogPostHeader.IProps) => {
    const { scrollProgress } = useScrollProgress("comments", "root");

    return (
        <div className={styles.container}>
            <div className={styles.titleContainer}>
                <Button
                    design={BUTTON_DESIGNS.PLAIN_TEXT}
                    content={<IoChevronBackOutline size="1.3rem" />}
                    className={styles.backButton}
                    onClick={() => {
                        if (preview) {
                            handlePreviewPopup();
                            return;
                        }
                        if (isBrowser()) {
                            window.location.href = ROUTES.BLOG.urlPath;
                        }
                    }}
                />
                <h1 className={styles.title}>{title}</h1>
            </div>
            <LoadingIndicator
                applyTheme
                progress={scrollProgress}
                design={LOADING_INDICATOR_DESIGNS.progress_bar}
                progressType={LOADING_INDICATOR_PROGRESS_TYPES.controlled}
                className={styles.scrollProgress}
            />
        </div>
    );
};

BlogPostHeader.defaultProps = {};
